module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipeIndex"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.loaderHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "width": "100px",
      "src": "static/loader-gif.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n    ")])]), _vm._v(" "), _c('recipe-search-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    class: {
      'isBreakfast': _vm.isBreakfast,
      'isLunch': _vm.isLunch,
      'isDinner': _vm.isDinner,
      'isNight': _vm.isNight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "paddingMobile"
  }, [_c('div', {
    staticClass: "recipesContainer"
  }, [_c('div', {
    staticClass: "seasonalRecipes"
  }, [(_vm.isChristmas && _vm.seasonal.christmas.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Merry Christmas! Here are this years best picks",
      "recipes": _vm.seasonal.christmas,
      "grouping-type": "occasions",
      "grouping-route": "christmas"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isThanksGiving && _vm.seasonal.thanksgiving.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Happy Thanksgiving!",
      "recipes": _vm.seasonal.thanksgiving,
      "grouping-type": "occasions",
      "grouping-route": "thanksgiving"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEaster && _vm.seasonal.easter.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Happy Easter!",
      "recipes": _vm.seasonal.easter,
      "grouping-type": "occasions",
      "grouping-route": "easter"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHalloween && _vm.seasonal.halloween.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Happy Halloween!",
      "recipes": _vm.seasonal.easter,
      "grouping-type": "occasions",
      "grouping-route": "halloween"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDiwali && _vm.seasonal.diwali.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Happy Diwali!",
      "recipes": _vm.seasonal.diwali,
      "grouping-type": "occasions",
      "grouping-route": "diwali"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "timelyRecipes"
  }, [(_vm.timely.recipes.length > 0) ? _c('div', [(_vm.isBreakfast) ? _c('div', [(_vm.timely.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Browse today's breakfast recipes",
      "groupingType": "categories",
      "groupingRoute": "breakfast",
      "recipes": _vm.timely.recipes
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isLunch) ? _c('div', [(_vm.timely.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Browse today's lunch recipes",
      "groupingType": "categories",
      "groupingRoute": "lunch",
      "recipes": _vm.timely.recipes
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isDinner) ? _c('div', [(_vm.timely.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Browse this evening's dinner recipes",
      "groupingType": "categories",
      "groupingRoute": "dinner",
      "recipes": _vm.timely.recipes
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isNight) ? _c('div', [(_vm.timely.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Get ready for tomorrow morning's breakfast",
      "groupingType": "categories",
      "groupingRoute": "breakfast",
      "recipes": _vm.timely.recipes
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.allergiesExcluded.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "linkTo": "dietaryTypes",
      "grouping-type": "allergies",
      "grouping-route": _vm.allergyCsv,
      "title": "Based on your allergies",
      "recipes": _vm.allergiesExcluded.recipes
    }
  }) : _vm._e(), _vm._v(" "), (_vm.favoriteBased.recipes.length > 0) ? _c('horizontal-scroller', {
    attrs: {
      "title": "Based on your favourites",
      "groupingType": "favourites",
      "groupingRoute": _vm.favoriteFoodsCsv,
      "recipes": _vm.favoriteBased.recipes
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-row', {
    staticClass: "dietaryTypes",
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.dietaryTypes.recipes), function(item, dtIndex) {
    return (item.recipes.length > 3) ? _c('mu-col', {
      key: 'dt-index-' + dtIndex,
      attrs: {
        "width": "100",
        "desktop": "100",
        "tablet": "100"
      }
    }, [_c('horizontal-scroller', {
      attrs: {
        "title": item.grouping,
        "groupingType": "dietaryTypes",
        "grouping-route": item.grouping,
        "recipes": item.recipes
      }
    })], 1) : _vm._e()
  }), 1), _vm._v(" "), (!_vm.cuisines.recipes.length > 0) ? _c('div', {
    ref: "scroll-detector"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAppending),
      expression: "isAppending"
    }],
    attrs: {
      "size": 32
    }
  })], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "cuisines",
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.cuisines.recipes), function(item, cIndex) {
    return (item.recipes.length > 3) ? _c('mu-col', {
      key: 'c-index-' + cIndex,
      attrs: {
        "width": "100",
        "desktop": "100",
        "tablet": "100"
      }
    }, [_c('horizontal-scroller', {
      attrs: {
        "title": item.grouping,
        "groupingType": "cuisines",
        "grouping-route": item.grouping,
        "recipes": item.recipes
      }
    })], 1) : _vm._e()
  }), 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17b579e0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Index.vue
// module id = 3062
// module chunks = 1